<div class="row">
  <div class="col-12 text-right text-muted text-sm-right">
    {{authString}}
  </div>
</div>
